import React, { useEffect, useState } from "react";
import Footer from "../homePage/components/footer/Footer";
// import FaSearch from "@react-icons/all-files/fa/FaSearch";
// import FaTimes from "@react-icons/all-files/fa/FaTimes";
import blogData from "./BlogsData";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getBlogListApi,
  getBlogWithRowidApi,
} from "../../../redux/reduxApi/admin/BlogListReduxApi";
import { getBlogCategoryApi } from "../../../redux/reduxApi/admin/BlogCategoryReducApi";
// import { IoMenuSharp } from "react-icons/io";
import {
  Button,
  Checkbox,
  Toast,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Box,
} from "@chakra-ui/react";
import { FaLongArrowAltLeft, FaSearch, FaTimes } from "react-icons/fa";
import { IoMenuSharp } from "react-icons/io5";

export default function SingleBlogPage() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const blogsDetails = useSelector((state) => state.BlogList.blogsDetails);
  const BlogsCatgiroy = useSelector(
    (state) => state.BlogCategory.getBlogCategory.blogCategories
  );
  const blogData = useSelector((state) => state.BlogList.getBlogList.blogs);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);
  useEffect(() => {
    const getData = async () => {
      await dispatch(getBlogWithRowidApi(id));
      await dispatch(getBlogListApi());
      await dispatch(getBlogCategoryApi());
    };

    getData();
  }, [dispatch, id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSearchChange = async (e) => {
    e.preventDefault();
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);

    if (!searchTerm) {
      setSearchResults([]);
      await dispatch(getBlogListApi()); // Fetch all blogs but do not display them in search results
      return;
    }

    const filterdata = {
      search: [
        {
          field: "title",
          operation: "like",
          value: searchTerm,
        },
      ],
    };

    try {
      const response = await dispatch(getBlogListApi(filterdata));
      console.log("this is filter response: ", response);
      setSearchResults(response.payload.data.blogs);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleClearSearch = async () => {
    setSearchTerm(" ");
    setSearchResults([]);
    await dispatch(getBlogListApi()); // Fetch all blogs but do not display them in search results
  };

  const recentBlogs = blogData ? blogData.slice(0, 5) : [];
  const recentCategories = BlogsCatgiroy ? BlogsCatgiroy.slice(0, 5) : [];

  return (
    <div className="">
      <div className="flex lg:flex-row flex-col-reverse lg:w-10/12 md:w-full w-full mx-auto lg:mt-4">
        <div className="lg:w-9/12 mx-auto lg:px-0 md:px-12 w-full lg:mr-20 my-3">
          <div className="lg:hidden block">
            <Button className=" bg-white block" onClick={toggleDrawer}>
              <IoMenuSharp className="h-6 w-7 me-2" /> Show Sidebar
            </Button>
          </div>

          {blogsDetails &&
            blogsDetails.length > 0 &&
            blogsDetails.map((blog) => (
              <div key={blog.rowId} className="lg:p-4 md:p-4 p-2">
                <div className="">
                  <Link to="/blog">
                      <button className="bg-orange-500 text-white px-3 py-1 rounded-full flex gap-2 items-center ">
                        <FaLongArrowAltLeft /> Back
                      </button>
                    </Link>

                  <img
                    src={blog.uploadImage}
                    alt={blog.blogTitle}
                    className="w-full object-cover h-[400px] object-top rounded-lg lg:mt-5 lg:mr-10"
                  />
                </div>
                <h5 className="mb-2 lg:text-2xl font-semibold text-gray-900 dark:text-white md:text-xl text-xl truncate mt-4">
                  {blog.blogTitle}
                </h5>

                {/* <div dangerouslySetInnerHTML={{ __html: blog.description }} /> */}
                <Box
                  dangerouslySetInnerHTML={{ __html: blog?.description || "" }}
                />
              </div>
            ))}
        </div>
        <div className="lg:w-3/12 md:w-4/12 flex flex-col pt-4 d-none d-lg-block">
          <div className="w-full flex justify-center items-center border rounded-xl ml-2 mb-4 overflow-hidden mt-4">
            <input
              type="text"
              placeholder="Search"
              className="flex-1 outline-none px-2 p-1 text-slate-500 w-50"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm && (
              <FaTimes
                className="text-white-500 mr-2 cursor-pointer"
                onClick={handleClearSearch}
              />
            )}
            <FaSearch
              className="text-white-500 mr-2"
              // onClick={handleSearchChange}
            />
          </div>

          {/* Search Results Section */}
          {searchResults.length > 0 && (
            <div className="search-results">
              <h5>Search Results</h5>
              <hr />
              <ul className="ps-0">
                {searchResults.map((result) => (
                  <li
                    key={result.rowId}
                    className="flex justify-evenly pt-2"
                    onClick={() =>
                      navigate(`/blog/single-blog/${result.rowId}`)
                    }
                  >
                    <img
                      src={result.uploadImage}
                      className="h-14 w-14 rounded-lg mr-2 cursor-pointer"
                    />
                    <h5 className="text-base font-bold cursor-pointer">{result.blogTitle}</h5>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Blog Categories Section */}
          <h5>Blog Categories</h5>
          <hr />
          <div className="overflow-y-auto max-h-[200px]">
            <ul className="ps-0 text-blue-900">
              {recentCategories.map((category) => (
                <li
                  key={category.rowId}
                  className="pt-2 hover:cursor-pointer"
                  onClick={() => {
                    navigate(`/blog/${category.categoryName}`);
                  }}
                >
                  <h5 className="text-base font-bold">
                    {category.categoryName}
                  </h5>
                </li>
              ))}
            </ul>
          </div>

          {/* Recent Posts Section */}
          <h5>Recent Posts</h5>
          <hr />
          <ul className="ps-0">
            {recentBlogs.map((recentBlog) => (
              <li
                key={recentBlog.rowId}
                className="flex justify-evenly pt-2 hover:cursor-pointer"
                onClick={() =>
                  navigate(`/blog/single-blog/${recentBlog.rowId}`)
                }
              >
                <img
                  src={recentBlog.uploadImage}
                  className="h-14 w-14 rounded-lg mr-2 cursor-pointer"
                />
                <h5 className="text-base font-bold cursor-pointer">{recentBlog.blogTitle}</h5>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Drawer
        isOpen={isDrawerOpen}
        placement="left"
        onClose={toggleDrawer}
        size="xs"
        className="lg:hidden"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Filter</DrawerHeader>
          <DrawerBody className=" p-4">
            <div className="w-full flex justify-start items-center border rounded-xl my-2 overflow-hidden ">
              <input
                type="text"
                placeholder="Search"
                className="flex-1 outline-none px-2 p-1 text-slate-500 w-50"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              {searchTerm && (
                <FaTimes
                  className="text-white-500 mr-2 cursor-pointer"
                  onClick={handleClearSearch}
                />
              )}
              <FaSearch
                className="text-white-500 mr-2"
                // onClick={handleSearchChange}
              />
            </div>

            {/* Search Results Section */}
            {searchResults.length > 0 && (
              <div className="search-results">
                <h5>Search Results</h5>
                <hr />
                <ul className="ps-0">
                  {searchResults.map((result) => (
                    <li
                      key={result.rowId}
                      className="flex justify-evenly pt-2"
                      onClick={() =>
                        navigate(`/blog/single-blog/${result.rowId}`)
                      }
                    >
                      <img
                        src={result.uploadImage}
                        className="h-14 w-14 rounded-lg mr-2"
                      />
                      <h5 className="text-base font-bold">
                        {result.blogTitle}
                      </h5>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Blog Categories Section */}
            <h5>Blog Categories</h5>
            <hr />
            <div className="overflow-y-auto max-h-[200px]">
              <ul className="ps-0 text-blue-900">
                {recentCategories.map((category) => (
                  <li
                    key={category.rowId}
                    className=" hover:cursor-pointer"
                    onClick={() => {
                      navigate(`/blog/${category.categoryName}`);
                    }}
                  >
                    <p className="text-base font-bold">
                      {category.categoryName}
                    </p>
                  </li>
                ))}
              </ul>
            </div>

            {/* Recent Posts Section */}
            <h5>Recent Posts</h5>
            <hr />
            <div className="overflow-y-auto max-h-[200px]">
              <ul className="ps-0">
                {recentBlogs.map((recentBlog) => (
                  <li
                    key={recentBlog.rowId}
                    className="flex justify-evenly pt-2 hover:cursor-pointer"
                    onClick={() =>
                      navigate(`/blog/single-blog/${recentBlog.rowId}`)
                    }
                  >
                    <img
                      src={recentBlog.uploadImage}
                      className="h-10 w-10 rounded-lg mr-2"
                    />
                    <p className="text-base font-bold">
                      {recentBlog.blogTitle}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </DrawerBody>
          {/* <DrawerFooter className="flex items-center justify-center">
            <Button
              onClick={() => {
                applyPriceFilter();
                toggleDrawer();
              }}
              colorScheme="blue"
              className="m-2"
            >
              Apply Filter
            </Button>
          </DrawerFooter> */}
        </DrawerContent>
      </Drawer>
    </div>
  );
}
